import styled, { css } from "styled-components";
import { token } from "./token.js";
import { textStyles } from "./textStyles.js";
const InputWrapper = styled.div.withConfig({
  displayName: "InputWrapper",
  componentId: "sc-108g0a0-0"
})(["", " display:flex;align-items:center;box-sizing:border-box;width:100%;height:var(--ds-input-height);padding:0 var(--ds-input-side-padding);border:1px solid ", ";border-radius:", ";background:", ";&:hover{border-color:", ";box-shadow:", ";}&:focus-within{border-color:", ";box-shadow:0 0 0 3px ", ";}", ";", ";"], (props) => props.$isSmall ? css(["--ds-input-height:32px;--ds-input-side-padding:", ";--ds-input-icons-gap:", ";"], token.spacing4, token.spacing2) : css(["--ds-input-height:40px;--ds-input-side-padding:", ";--ds-input-icons-gap:", ";"], token.spacing5, token.spacing3), (props) => props.$isInvalid ? token.red500 : token.gray100, token.radiusMedium, token.gray10, (props) => props.$isInvalid ? token.red600 : token.gray200, token.elevation1, (props) => props.$isInvalid ? token.red500 : token.gray300, token.gray100, (props) => props.$isDisabled && css(["border-color:", ";background:", ";color:", ";cursor:not-allowed;&:hover{border-color:", ";box-shadow:none;}"], token.gray100, token.gray25, token.gray600, token.gray100), (props) => props.$variant === "clean" && css(["border-color:transparent;box-shadow:none;&:hover{border-color:transparent;background:", ";box-shadow:none;}&:focus-within{border-color:transparent;background:", ";box-shadow:none;}"], token.gray25a, token.gray50a));
const InputStyled = styled.input.withConfig({
  displayName: "InputStyled",
  componentId: "sc-108g0a0-1"
})(["&&&{flex:1;width:auto;min-width:0;height:100%;margin:0;padding:0;border:0;background:transparent;color:", ";box-shadow:none;outline:none;font-family:", ";", " &::-webkit-inner-spin-button,&::-webkit-outer-spin-button{display:none;margin:0;appearance:none;}&[type='number']{appearance:textfield;}&::placeholder{color:", ";}&:disabled{color:", ";cursor:not-allowed;&::placeholder{color:", ";}}}"], token.colorText, token.brandFontStackBase, textStyles.uiTextM, token.gray400, token.gray600, token.gray400);
const LeftItems = styled.div.withConfig({
  displayName: "LeftItems",
  componentId: "sc-108g0a0-2"
})(["display:flex;gap:var(--ds-input-icons-gap);align-items:center;margin-right:var(--ds-input-icons-gap);&:empty{display:none;}"]);
const IconLeftContainer = styled.div.withConfig({
  displayName: "IconLeftContainer",
  componentId: "sc-108g0a0-3"
})(["flex:none;margin-left:calc(", " * -1);color:", ";"], token.spacing2, token.gray600);
const PrefixContainer = styled.div.withConfig({
  displayName: "PrefixContainer",
  componentId: "sc-108g0a0-4"
})(["color:", ";"], (props) => props.$isDisabled ? token.gray400 : token.gray600);
const RightItems = styled.div.withConfig({
  displayName: "RightItems",
  componentId: "sc-108g0a0-5"
})(["display:flex;flex:none;gap:var(--ds-input-icons-gap);align-items:center;margin-right:calc(", " * -1);margin-left:var(--ds-input-icons-gap);&:empty{display:none;}"], token.spacing2);
const SuffixContainer = styled.div.withConfig({
  displayName: "SuffixContainer",
  componentId: "sc-108g0a0-6"
})(["color:", ";&:last-child{margin-right:", ";}"], (props) => props.$isDisabled ? token.gray400 : token.gray600, token.spacing2);
const IconRightContainer = styled.div.withConfig({
  displayName: "IconRightContainer",
  componentId: "sc-108g0a0-7"
})(["display:grid;flex:none;align-items:center;color:", ";"], token.gray600);
const ClearButton = styled.button.withConfig({
  displayName: "ClearButton",
  componentId: "sc-108g0a0-8"
})(["flex:none;padding:0;border:none;background:transparent;color:", ";cursor:pointer;&:hover,&:focus{color:", ";outline:none;}&:active{color:", ";}"], token.gray200a, token.gray300a, token.gray400a);
export {
  ClearButton,
  IconLeftContainer,
  IconRightContainer,
  InputStyled,
  InputWrapper,
  LeftItems,
  PrefixContainer,
  RightItems,
  SuffixContainer
};
//# sourceMappingURL=Input.styles.js.map
